import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useConfrimCookie from 'shared/model/useConfrimCookie'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetManagerId = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, , deleteConfrimCookie] = useConfrimCookie()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const request = () => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest('GET', `/${rolePath}/auth/manager/id`)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('가입된 계정이 아닙니다.')
					deleteConfrimCookie()
				}
				break
		}
	}, [fetchResult])

	return [fetchResult, request]
}

export default useGetManagerId
